import './styles.scss'
import React from 'react'
import { Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { getFlightDateTime, getFormatTravelTime, calculateTimeBetweenHours } from '../../../utils/helpers'

const { REACT_APP_DNS_WEBVIEW } = process.env

const defaultTail = `${REACT_APP_DNS_WEBVIEW}/tails/default.png`
const getDetailedFlightRow = (legs, view) =>
  Object.keys(legs).map((leg) => {
    const boundType = leg
    const flightView = view
    if (!flightView[boundType]) return null

    const numStops = flightView[boundType].scales.length
    return (
      <div className={'row text-center mb-3 ' + boundType} key={leg}>
        <div className='col-12 flight-details-bound-header'>
          <div className='title'>
            <div className='flight-details-bound-type mr-1'>{I18n.t(`flight.${boundType}`)}:</div>
            <div className='flight-details-destinations'>
              <div className='d-inline-block'>{flightView[boundType].scales[0].origin}</div>
              <span> - </span>
              <div className='d-inline-block'>{flightView[boundType].scales[numStops - 1].destination}</div>
            </div>
          </div>
          <div className='subtitle'>
            {flightView[boundType].departureDay} -&nbsp;
            <span>
              {flightView[boundType].duration}
              {flightView[boundType].scales.length - 1 ? ` - ${flightView[boundType].scales.length - 1} ${I18n.t('flight.stops')}` : null}
            </span>
          </div>
        </div>
        <div className='col-12 flight-details-bound-info'>
          <div className='info'>
            {legs[leg].segments.map((stop, i) => {
              let departureTime = getFlightDateTime(stop.departureDateTime)
              let arrivalTime = getFlightDateTime(stop.arrivalDateTime)
              let notLastSegment = legs[leg].segments.length > 1 && i !== legs[leg].segments.length - 1
              let nextDepartureTime = ''

              if (notLastSegment) {
                nextDepartureTime = legs[leg].segments[i + 1].departureDateTime
                nextDepartureTime = getFlightDateTime(nextDepartureTime)
              }

              return (
                <div className='scale d-block text-center py-2' key={i}>
                  <div className='col-12 mb-2'>
                    <img
                      onError={(e) => (e.target.src = defaultTail)}
                      className='tail'
                      src={`${REACT_APP_DNS_WEBVIEW}/tails/${stop.carrier}.png`}
                      alt={stop.carrier}
                    />
                    <div className='airline-name d-inline-block'>{flightView[boundType].scales[i].airline}</div>
                  </div>
                  <div className='row'>
                    <div className='col-5'>
                      <div>
                        <span>{stop.origin}</span>
                      </div>
                      <div>{departureTime}</div>
                    </div>
                    <div className='col'>
                      <div className='arrow'></div>
                      <div className='mt-2'>
                        <span className='duration'>{getFormatTravelTime(stop.travelTime)}</span>
                      </div>
                    </div>
                    <div className='col-5'>
                      <div>
                        <span>{stop.destination}</span>
                      </div>
                      <div>{arrivalTime}</div>
                    </div>
                  </div>
                  <div className='row justify-content-between mt-2'>
                    <div className='col-5 stop-city'>
                      <div>{flightView[boundType].scales[i].origin}</div>
                    </div>
                    <div className='col'></div>
                    <div className='col-5 stop-city'>
                      <div>{flightView[boundType].scales[i].destination}</div>
                    </div>
                  </div>
                  {notLastSegment && (
                    <div className='col-12 mx-auto mt-3'>
                      <div className='scale-separator'>
                        <i className='fa fa-clock-o' aria-hidden='true' />
                        <div className='d-inline-block mx-1 scale-info'>
                          {I18n.t('flight.scaleOf')}&nbsp;
                          {getFormatTravelTime(calculateTimeBetweenHours(arrivalTime, nextDepartureTime))}
                          &nbsp;{I18n.t('flight.in')}&nbsp;
                          {stop.destination}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* <div className="col-12 mt-2 p-4 luggage d-none">
                  <div className="row align-items-center luggage-header">
                    <div className="col text-left">
                      <span>{I18n.t('flight.luggage')}</span>
                    </div>
                    <div className="col text-right">
                      <div className="luggage-icon d-inline-block mr-1">
                        <img src="/icons/luggage.svg" width="20px" alt="Luggage" title="Luggage" />
                      </div>
                      <div className="luggage-arrow d-inline-block ml-1">
                        <img src="/icons/triangle-arrow.svg" width="10px" alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="container">
                      <div className="col-2"></div>
                      <div className="col-10"></div>
                    </div>
                  </div>
                </div> */}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  })

const getFlightRow = (leg, view) => (
  <Row className='flight-row'>
    <Col xs={4}>
      <div>
        <span className='d-inline-block'>
          <img
            onError={(e) => (e.target.src = defaultTail)}
            className='airline-tail mr-2'
            src={`${REACT_APP_DNS_WEBVIEW}/tails/${leg.mayorCarrier}.png`}
            alt={leg.mayorCarrier}
          />
        </span>
        <span className='d-inline-block'>
          <div className='airline-name'>{view.scales[0].airline}</div>
          <div className='flight-number'>
            {view.scales[0].airlineIata} {view.scales[0].flightNumber}
          </div>
        </span>
      </div>
    </Col>
    <Col xs={4} className='text-center'>
      <div className='flight-city'>
        <span>
          {view.origin} ({leg.segments[0].origin})
        </span>{' '}
        &#8594;{' '}
        <span>
          {view.destination} ({leg.segments[0].destination})
        </span>
      </div>
      <div className='flight-duration'>{view.duration}</div>
      <div className='flight-stops'>
        {view.scales.length - 1 === 0 ? I18n.t('flight.direct') : `${view.scales.length - 1} ${I18n.t('flight.stops')}`}
      </div>
    </Col>
    <Col xs={4} className='text-center'>
      <div className='flight-dates'>
        <span>
          {view.departureDay} &nbsp;&nbsp; {view.arrivalDay}
        </span>
      </div>
      <div className='flight-times'>
        {view.departureTime} &#8594; {view.arrivalTime}
      </div>
    </Col>
  </Row>
)

const Index = ({ flight, selected, detailed, handleSelectResult, handleShowDetails, ...rest }) => (
  <div className={`flight-card${selected}${detailed}`} {...rest}>
    <div>
      <Row className='align-items-center'>
        {detailed ? (
          <Col onClick={handleSelectResult}>{getDetailedFlightRow(flight.legs, flight.view)}</Col>
        ) : (
          <Col onClick={handleSelectResult}>
            {getFlightRow(flight.legs.outbound, flight.view.outbound)}
            {flight.legs.inbound && flight.view.inbound && getFlightRow(flight.legs.inbound, flight.view.inbound)}
          </Col>
        )}
        <Col xs={2}>
          <strong>
            {Math.ceil(flight.booking.price.total)} {flight.booking.price.currencyCode}
          </strong>
          <div className='flight-provider'>
            {flight.providerKey && flight.providerKey.length > 0
              ? I18n.t(`dashboard_providers-${flight.providerKey}`)
              : I18n.t(`dashboard_providers-api_${flight.provider.toLowerCase()}`)}
          </div>
          <small className='mr-1 show-details' onClick={handleShowDetails}>
            {detailed ? I18n.t('dashboard_hide-details') : I18n.t('dashboard_show-details')}
          </small>
        </Col>
      </Row>
    </div>
  </div>
)

export default Index
